import React from "react";
import AnimatedHeroText from "js/components-v2/common/AnimatedHeroText/AnimatedHeroText";
import AnimatedItem from "js/components-v2/common/AnimatedHeroText/AnimatedItem";
import StartNow from "js/components-v2/common/StartNow/StartNow";
import Icon from "js/components-v2/common/StartNow/Icon";
import HeroButtons from "js/components-v2/pages/MSellerPage/HeroButtons";
import HomeVideo from "js/components-v2/pages/HomePage/HomeVideo";
import userCountry from 'js/services/UserCountry';

const HeroSection = ({mseller, activationHandler}) => {
  const [active, setActive] = React.useState(0);

  return (
    <>
      <div>
        <div className='d-md-flex'>
          <div className="hero-media d-md-flex align-items-center">
            <HomeVideo setActive={setActive} active={active} />
          </div>
          <div className='hero-text'>
            <div className="hero-section">
              <AnimatedHeroText>
                <AnimatedItem className={0 === active ? 'active' : ''}>
                  <h1>Sell your stuff anywhere hassle free</h1>
                  <p>with POD, you can focus on your sales, while we take care of your transaction and delivery anywhere in Lagos</p>
                </AnimatedItem>

                <AnimatedItem className={1 === active ? 'active' : ''}>
                  <h1>Same day door to door delivery</h1>
                  <p>with POD, you can focus on your sales, while we take care of your transaction and delivery anywhere in Lagos</p>
                </AnimatedItem>

                <AnimatedItem className={2 === active ? 'active' : ''}>
                  <h1>Fast payments to sellers within 24 hours</h1>
                  <p>with POD, you can focus on your sales, while we take care of your transaction and delivery anywhere in Lagos</p>
                </AnimatedItem>
              </AnimatedHeroText>
            </div>
            <HeroButtons mseller={mseller} activationHandler={activationHandler}/>
          </div>
        </div>

      </div>
    </>
  );
};

export default HeroSection;
